<template>
  <div class="page-div">
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
    />
    <div class="form-div">
      <div class="row-div">
        <img src="../../assets/accountNumberManagement/notice.png" width="19px" height="19px">
        <div class="notice-div">
          如有漏气、爆炸、着火、人员伤亡、等紧急燃气事件，请立即拨打服务热线：<span class="phone-span">96777</span>
        </div>
      </div>
      <div class="label-div">报修人姓名</div>
      <van-field v-model="repairApplicantName" readonly/>
      <div class="label-div">报修人电话</div>
      <van-field v-model="reportTelephone" readonly/>
      <div class="label-div">燃气用户编号</div>
      <van-field v-model="userNumber" readonly/>
      <!--<div class="label-div">燃气用户编号<span class="required-span">*</span></div>
      <van-field v-model="userNumber" placeholder="请选择" readonly>
        <template #button>
          <van-button class="choose-button" @click="chooseUserNumber()">选择</van-button>
        </template>
      </van-field>
      <van-popup v-model="showUserNumberPicker" position="bottom" round>
        <van-picker
          show-toolbar
          :columns="userNumberColumns"
          value-key="userCode"
          @confirm="onUserNumberConfirm"
          @cancel="showUserNumberPicker = false"
        />
      </van-popup>-->
      <van-field type="textarea" readonly input-align="right" autosize>
        <template #label>
          地址<span class="required-span">*</span>
        </template>
        <template #input>
          <div class="correct-address-div">
            地址不对？请拨打
            <span class="correct-address-span">96777</span>
            修改
          </div>
          <textarea v-model="repairAddress" readonly></textarea>
        </template>
      </van-field>
      <div class="label-div">报修类型<span class="required-span">*</span></div>
      <van-field v-model="formType" placeholder="请选择" readonly>
        <template #button>
          <van-button class="choose-button" @click="chooseFormType()">选择</van-button>
        </template>
      </van-field>
      <van-popup v-model="showFormTypePicker" position="bottom" round>
        <van-picker
          show-toolbar
          :columns="formTypeColumns"
          value-key="meaning"
          @confirm="onFormTypeConfirm"
          @cancel="showFormTypePicker = false"
        />
      </van-popup>
      <div class="label-div">备注<span class="required-span">*</span></div>
      <van-field v-model="remarks" placeholder="请详细描述维修对象、损坏情况等；如联系人不是报修人，请填写联系人和电话" autosize type="textarea"/>
      <div class="pic-row-div">
        <div class="left-cell">添加图片</div>
        <div class="right-cell">您可以上传图片以便我们更好的服务</div>
      </div>
      <van-uploader v-model="uploader" :upload-icon="require('../../assets/bao-xiu/camera.png')" :max-count="2"/>
      <van-button color="#CE0022" class="login-button button-shadow" @click="submitRepair()">提交</van-button>
    </div>
    <!-- <div class="button-div">
    </div> -->
  </div>
</template>

<script>
import { getUserGasList } from '../../api/accountNumberManagement'
import { codeValueList, addrepairs } from '../../api/repair'

export default {
  name: 'ReportRepair',
  data () {
    return {
      userNumber: '', // 燃气用户编号
      repairApplicantName: '', // 报修人姓名
      reportTelephone: '', // 报修人电话
      repairAddress: '', // 地址
      showUserNumberPicker: false, // 是否展示燃气用户编号选择器
      userNumberColumns: [], // 燃气用户编号列表
      formType: '', // 报修类型
      formTypeValue: '', // 报修类型值
      showFormTypePicker: false, // 是否展示报修类型选择器
      formTypeColumns: [], // 报修类型列表
      remarks: '', // 备注
      uploader: [], // 报修图片
      title: '', // 页面标题
      typeMap: {
        '管道阀门报修': 'BG_GAS_PIPE',
        '燃气表报修': 'BG_GAS_METER',
        '燃气具报修': 'BG_GAS_STOVE',
        '其他报修': 'BG_GAS_OTHER',
        '燃气预约巡检': 'BG_GAS_INSPECTSUB',
        '燃气拆改': 'BG_GAS_MODIFY'
      }, // 报修类型
      repairType: '', // 报修类型
      repairTypeChina: '', // 报修类型中文
      meterType: false,
      meterTypeChina: '', // 卡表厂家
      meterTypes: [
        '泰科',
        '思凯',
        '天庆',
        '其他'
      ], // 卡表厂家列表
      cardChar: 'C', // 卡表的标志
      appContactId: '',
      userId: '',
      gasAccountInfo: {} // 户号信息
    }
  },
  mounted () {
    if (this.$route.params.type == '管道阀门' || this.$route.params.type == '燃气表' || this.$route.params.type == '燃气具') {
      this.title = this.$route.params.type + '报修'
      this.repairTypeChina = this.$route.params.type + '报修'
    } else {
      this.title = this.$route.params.type
      this.repairTypeChina = this.$route.params.type
    }
    this.gasAccountInfo = this.$route.params.gasAccountInfo
    this.userNumber = this.$route.params.gasAccountInfo.gasAccount
    this.repairAddress = this.$route.params.gasAccountInfo.address
    this.meterType = (this.$route.params.gasAccountInfo.meterType == this.cardChar)
    this.repairApplicantName = JSON.parse(window.localStorage.userInfo).contacts
    this.appContactId = JSON.parse(window.localStorage.userInfo).appContactId
    this.userId = JSON.parse(window.localStorage.userInfo).id
    this.reportTelephone = JSON.parse(window.localStorage.userInfo).mobile
    // this.getNumberList()
    this.getRepairType()
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },

    // 选择燃气用户编号确认
    onUserNumberConfirm (value) {
      this.userNumber = value.userCode
      this.repairAddress = value.address
      this.meterType = (value.meterType == this.cardChar)
      this.showUserNumberPicker = false
    },

    // 显示燃气用户编号选择器
    chooseUserNumber () {
      this.showUserNumberPicker = true
    },

    // 显示报修类型选择器
    chooseFormType () {
      this.showFormTypePicker = true
    },

    // 选择报修类型确认
    onFormTypeConfirm (value) {
      this.formType = value.meaning
      this.formTypeValue = value.value
      this.showFormTypePicker = false
    },

    // 获取用户绑定的燃气号列表
    getNumberList () {
      const that = this
      that.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      const params = {
        userId: window.localStorage.userId
      }
      getUserGasList(params).then(res => {
        if (res.data.success) {
          if (res.data.rows.length > 0) {
            that.userNumberColumns = []
            for (let i = 0; i < res.data.rows.length; i++) {
              that.userNumberColumns.push(res.data.rows[i])
            }
            that.userNumber = that.userNumberColumns[0].userCode
            that.repairAddress = that.userNumberColumns[0].address
            that.meterType = (that.userNumberColumns[0].meterType == that.cardChar)
          } else {
            that.userNumber = '没有户号'
          }
          that.$toast.clear()
        } else {
          that.$toast.fail((res.data.message ? res.data.message : '获取用户编号异常'))
        }
      }).catch(() => {
        that.$toast.fail('获取用户编号异常')
      })
    },

    // 获取对应报修类型的具体报修类型信息
    getRepairType () {
      const that = this
      const params = {
        code: that.typeMap[that.repairTypeChina]
      }
      codeValueList(params).then(res => {
        if (res.data.success) {
          that.formTypeColumns = []
          for (let i = 0; i < res.data.rows.length; i++) {
            that.formTypeColumns.push(res.data.rows[i])
          }
        } else {
          that.$toast.fail((res.data.message ? res.data.message : '获取报修类型异常'))
        }
      }).catch(() => {
        that.$toast.fail('获取报修类型异常')
      })
    },

    // 提交
    submitRepair () {
      const that = this
      if (!that.userNumber || that.userNumber === '没有户号') {
        that.$toast('请选择燃气用户编号')
      } else if (!that.formType) {
        that.$toast('请选择报修类型')
      } else if (!that.remarks) {
        that.$toast('请填写备注信息')
      } else if (that.remarks && that.remarks.indexOf('|') > -1) {
        that.$toast('备注中不能包含“|”符号')
      } else {
        let userNote_ = that.remarks.split('\n').join('，')
        that.$toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration: 0
        })
        userNote_ = userNote_ + ((that.meterType && that.meterTypeChina) ? ('（卡表厂家：' + that.meterTypeChina + '）') : '')
        const formData = new FormData()
        formData.append('userNote', userNote_)
        const inputModel = {
          repairName: that.repairApplicantName,
          repairCall: that.reportTelephone,
          gasUserNumber: that.userNumber,
          detailedAddress: that.repairAddress,
          repairType: that.formTypeValue,
          repairTypeChina: that.formType,
          type: that.repairTypeChina,
          appContactId: that.appContactId,
          userId: that.userId,
          dataSource: 'Bjtong'
        }
        for (const i in inputModel) {
          formData.append(i, inputModel[i])
        }
        if (that.repairTypeChina !== '燃气预约巡检' && that.uploader.length > 0) {
          for (let j = 0; j < that.uploader.length; j++) {
            that.b64toBlob(that.uploader[j].content, function (blob) {
              formData.append('file', blob, that.repairApplicantName + '-报修-.jpg') // 文件对象bl
              if (j == (that.uploader.length - 1)) {
                that.onBolb(formData)
              }
            })
          }
        } else {
          that.onBolb(formData)
        }
      }
    },

    // b64转Blob
    b64toBlob (b64, onsuccess, onerror) {
      const img = new Image()
      img.onerror = onerror
      img.onload = function onload () {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const width = img.width
        const height = img.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(onsuccess)
      }
      img.src = b64
    },

    // 提交报修信息
    onBolb (formData) {
      const that = this
      addrepairs(formData).then(res => {
        if (res.data.success) {
          let userInfo = JSON.parse(window.localStorage.userInfo)
          userInfo.appContactId = res.data.rows[0].appContactId
          window.localStorage.userInfo = JSON.stringify(userInfo)
          that.$toast.clear()
          that.$dialog.alert({
            message: '创建报修单成功'
          }).then(() => {
            that.$router.go(-1)
          })
        } else {
          that.$toast.fail(res.data.message)
        }
      }).catch((err) => {
        that.$toast.fail('提交失败')
      })
    }
  }
}
</script>

<style scoped>
  .van-cell {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    padding: 12px 0;
    border-bottom: 1px solid rgba(16, 12, 13, 0.0784313725490196);
  }

  /deep/ .van-field__label {
    color: #62667A;
  }

  /deep/ .van-field__control {
    color: #27282E;
  }

  .label-div {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #27282E;
    text-align: left;
    margin-top: 15px;
  }

  .form-div {
    padding: 0 4% 20px 4%;
    height: calc(100% - 60px);
    overflow: auto;
  }

  .required-span {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FF7825;
    margin-left: 1px;
  }

  .login-button {
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 20px;
  }

  .button-shadow {
    box-shadow: 0px 6px 12px rgba(206, 0, 34, 0.3);
  }

  .button-div {
    width: 92%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 4%;
  }

  .row-div {
    display: flex;
  }

  .notice-div {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: #DB0000;
    text-align: left;
    margin-left: 4px;
  }

  .phone-span {
    color: #333333;
  }

  .choose-button {
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 26px;
    color: #CE0022;
    border: none;
  }

  .correct-address-div {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  /deep/ .van-field__control--custom {
    flex-direction: column;
    align-items: flex-end;
  }

  textarea {
    text-align: right;
    border: none;
    width: 100%;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 23px;
    color: #27282E;
  }

  .correct-address-span {
    color: #CE0022;
  }

  .right-cell {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: #999999;
    text-align: right;
    width: 70%;
  }

  .left-cell {
    width: 30%;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 22px;
    color: #27282E;
  }

  .pic-row-div {
    display: flex;
    margin: 16px 0 13px 0;
    align-items: center;
  }

  /deep/ .van-uploader__upload-icon {
    font-size: 34px;
  }

  /deep/ .van-uploader__upload {
    background-color: #FFF;
    border: 1px solid #F6D5DA;
    border-radius: 8px;
  }

  .page-div {
    height: 100%;
  }
</style>
